let userLang = JSON.parse(window.localStorage.getItem("userLangDetail"));
export const getLocalStorage = () => {
  userLang = JSON.parse(window.localStorage.getItem("userLangDetail"));
  HeaderData = {
    columns: [
      {
        label: userLang?.common?.TRANSPORTER,
        field: "transporterName",
        sort: "asc",
        width: 2,
      },
      {
        label: userLang?.common?.VEHICLE_TYPE,
        field: "vehicleType",
        sort: "asc",
        width: 2,
      },
      {
        label: userLang?.report?.NO_OF_INDENT,
        field: "indentNo",
        sort: "asc",
        width: 1,
      },
    ],
  };
};
if (localStorage.getItem("userLangDetail") === null) {
  getLocalStorage();
}
export var HeaderData = {
  columns: [
    {
      label: userLang?.common?.TRANSPORTER,
      field: "transporterName",
      sort: "asc",
      width: 2,
    },
    {
      label: userLang?.common?.VEHICLE_TYPE,
      field: "vehicleType",
      sort: "asc",
      width: 2,
    },
    {
      label: userLang?.report?.NO_OF_INDENT,
      field: "indentNo",
      sort: "asc",
      width: 1,
    },
  ],
};
export const searchBar = {
  searchBarData: [
    {
      label: userLang?.common?.TRANSPORTER,
      field: "status",
      sort: "asc",
      width: 1,
    },
    {
      label: userLang?.common?.VEHICLE_TYPE,
      field: "vehicleType",
      sort: "asc",
      width: 1,
    },
    {
      label: userLang?.report?.NO_OF_INDENT,
      field: "indentNo",
      sort: "asc",
      width: 1,
    },
  ],
};
